import { render, staticRenderFns } from "./App.vue?vue&type=template&id=38ac390e&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=38ac390e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ac390e",
  null
  
)

export default component.exports